import { loadYoutubeApi } from '../../js/helper';

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $contentVideos = $context.querySelectorAll('[data-contentvideo="root"]');
        const $howToVideos = $context.querySelectorAll('[data-howtovideos="root"]');
        const $mediaSlider = $context.querySelectorAll('[data-mediaslider-video="root"]');

        if ($contentVideos.length > 0 || $howToVideos.length > 0 || $mediaSlider.length > 0) {
            const waitForConsent = setInterval(() => {
                if (typeof CookieConsent !== 'undefined') {
                    console.log(CookieConsent.consent.marketing); // eslint-disable-line
                    if (CookieConsent.consent.marketing === true) { // eslint-disable-line
                        loadYoutubeApi();

                        window.onYouTubeIframeAPIReady = () => {
                            if ($contentVideos.length > 0) {
                                import('../../modules/content-video/content-video').then(({ ContentVideo }) => {
                                    for (let i = 0; i < $contentVideos.length; i++) {
                                        const contentVideoAPI = new ContentVideo($contentVideos[i]);
                                        $contentVideos[i].API = contentVideoAPI;
                                    }
                                });

                                $contentVideos.forEach($element => {
                                    $element.querySelectorAll('.media__restriction').forEach($mediaRestriction => {
                                        $mediaRestriction.remove();
                                    });
                                });
                            }

                            if ($howToVideos.length > 0) {
                                import('../../modules/how-to-videos/how-to-videos').then(({ HowToVideos }) => {
                                    for (let i = 0; i < $howToVideos.length; i++) {
                                        const howToVideosAPI = new HowToVideos($howToVideos[i], {
                                            loader: window.OPTIONS.loader,
                                            resizeHandler: window.resizeHandler
                                        });
                                        howToVideosAPI.API = howToVideosAPI;
                                    }
                                });

                                $howToVideos.forEach($element => {
                                    $element.querySelectorAll('.media__restriction').forEach($mediaRestriction => {
                                        $mediaRestriction.remove();
                                    });
                                });
                            }

                            if ($mediaSlider.length > 0) {
                                import('../../modules/media-slider/media-slider').then(({ MediaSlider }) => {
                                    for (let i = 0; i < $mediaSlider.length; i++) {
                                        const mediaSlider = new MediaSlider($mediaSlider[i]);
                                        mediaSlider.initialize();
                                    }
                                });

                                $mediaSlider.forEach($element => {
                                    $element.querySelectorAll('.media__restriction').forEach($mediaRestriction => {
                                        $mediaRestriction.remove();
                                    });
                                });
                            }
                        };
                    } else {
                        window.addEventListener('CookiebotOnAccept', () => {
                            if (CookieConsent.consent.marketing) { // eslint-disable-line
                                location.reload();
                            }
                        }, false);
                    }
                    clearInterval(waitForConsent);
                } else {
                    console.log('waiting for CookieContent');
                }
            }, 300);
        }
    }
});
